// extracted by mini-css-extract-plugin
export default {"uploadButton":"UploaderButton_uploadButton__vDfbe","doneButton":"UploaderButton_doneButton__ayy4S"};